import React from "react";
import styles from "./EanQuantityBundle.module.css";

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disableAnimation?: boolean;
  isLoading?: boolean;
  singleAisle?: boolean
};

export const EanQuantityBundle = ({
  children,
  onClick,
  className,
  disableAnimation = false,
  isLoading = false,
  singleAisle = false
}: Props) => {
  const combinedClasses = [
    styles.box,
    className,
    disableAnimation ? styles.noAnimation : "",
    isLoading ? styles.skeleton : "",
    singleAisle ? styles.singleAisleHighlight : ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={combinedClasses} onClick={!isLoading ? onClick : undefined}>
      {isLoading ? <></> : children}
    </div>
  );
};
